export const ERRORS = {
  REQUIRED: "Please provide an answer for this question",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_POSTCODE: "Enter a UK postcode, or contact us for help",
  INVALID_TEL: "Enter a valid phone number or contact us for help",
  INVALID_ZIPCODE: "Please enter a valid 5-digit ZIP code",
  INVALID_GENERIC: "The value entered is not valid.",
} as const;
